import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'trip.js/dist/trip.min.css'
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
import jQuery from 'jquery'
global.$ = jQuery

Vue.config.productionTip = false

Vue.use(Vuetify)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
